import(/* webpackMode: "eager", webpackExports: ["ContentSkeleton"] */ "/var/www/light_of_empire_front/shared/ui/ContentSkeleton/ContentSkeleton.tsx");
